import * as yup from 'yup'

export const validationSchema = yup.object().shape({
  verificationCode: yup
    .string()
    .matches(/^[0-9]+$/, 'Must be only digits')
    .min(6, 'Must be 6 characters')
    .max(6, 'Must be 6 characters')
    .required('Verification Code  is Required'),
})
